import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel, WX } from "@serenity-is/corelib";
import { ErrorHandling, htmlEncode, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText, text, notifyWarning, warning } from "@serenity-is/corelib/q";
import { PromptDialog } from "@serenity-is/extensions";
import { resolve } from "chart.js/dist/helpers/helpers.options";
import { ConfirmBySmsDialog } from "../../../ConfirmBySms/ConfirmBySmsDialog";
import { EnterSMSCodeDialog } from "../../../MyCabinet/EDO/LkDocumsForSign/EnterSMSCodeDialog";
import { ConfirmByEmailDialog } from "../../../NewAccount/ConfirmByEmail/ConfirmByEmailDialog";

let LoginPanelObj: LoginPanel;
let MobTel: string;
let Email: string;

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
/*    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }*/

    if ((document.getElementById('Activated') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val((document.getElementById('Activated') as HTMLInputElement)?.value);
        loginPanel["byId"]('Password').focus();
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }
    private strDABConfiguration;
    private EnterSMSCode: EnterSMSCodeDialog;
    public deferredPrompt: any; // Allows to show the install prompt
    public installButton: any;

    constructor(container: JQuery) {
        super(container);

        LoginPanelObj = this;

        let sDABConfiguration = text("MyCabinet.LKDABConfiguration.DABConfiguration");
        if (',dabsystems,'.indexOf(',' + sDABConfiguration + ',') > -1)
            this.addRuStoreButton();

        this.InstallPWAApp();

        var q = parseQueryString();
        var errorActivateLink = q['ErrorActivateLink'] || q['ErrorActivateLink'];

        if (errorActivateLink && errorActivateLink == "1") {
            warning(text("Forms.Membership.MospartnersLogin.WarningLinkActivateAccountExpired"));
        }

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: (response: any) => {
                    if (response?.CustomData?.SMSTWOFACTAUTH == "SET") {
                        serviceCall({
                            url: resolveUrl(`~/Account/GetMobTelNonAuth?strLogin=${request.Username}`),
                            onSuccess: (val) => {
                                var sTelMob = val[0];
                                if (sTelMob.length > 0) {
                                    MobTel = sTelMob;

                                    var csDlg = new ConfirmBySmsDialog();
                                    csDlg.sMobTel = MobTel;
                                    csDlg.dialogOpen();
                                    csDlg.element.bind('dialogbeforeclose', function (e) {
                                        if (csDlg.bConfirmResult) {
                                            serviceCall({
                                                url: resolveUrl('~/Account/Login'),
                                                request: request,
                                                onSuccess: (response: any) => {
                                                    if (response?.CustomData?.ANKETAREDIRECT == "1") {
                                                        window.location.href = '/MyCabinet/ClientFru';
                                                    }
                                                    else if (response?.CustomData?.ANKETAREDIRECT == "2") {
                                                        window.location.href = '/MyCabinet/ClientUru';
                                                    }
                                                    else {
                                                        LoginPanelObj.redirectToReturnUrl();
                                                    }
                                                },
                                            });
                                        }
                                    });
                                }
                            },
                        });
                    }
                    else if (response?.CustomData?.EMAILTWOFACTAUTH == "SET") {
                        serviceCall({
                            url: resolveUrl(`~/Account/GetEmailNonAuth?strLogin=${request.Username}`),
                            onSuccess: (val) => {
                                var sEmail = val[0];
                                if (sEmail.length > 0) {
                                    Email = sEmail;

                                    var ceDlg = new ConfirmByEmailDialog();
                                    ceDlg.sEmail = Email;
                                    ceDlg.sAuthentication = "1";
                                    ceDlg.dialogOpen();
                                    ceDlg.element.bind('dialogbeforeclose', function (e) {
                                        if (ceDlg.bConfirmResult) {
                                            serviceCall({
                                                url: resolveUrl('~/Account/Login'),
                                                request: request,
                                                onSuccess: (response: any) => {
                                                    if (response?.CustomData?.ANKETAREDIRECT == "1") {
                                                        window.location.href = '/MyCabinet/ClientFru';
                                                    }
                                                    else if (response?.CustomData?.ANKETAREDIRECT == "2") {
                                                        window.location.href = '/MyCabinet/ClientUru';
                                                    }
                                                    else {
                                                        LoginPanelObj.redirectToReturnUrl();
                                                    }
                                                },
                                            });
                                        }
                                    });
                                }
                            },
                        });
                    }
                    else {
                        if (response?.CustomData?.ADMINREDIRECT == "1") {
                            window.location.href = '/Administration/VisitStatistics';
                            return;
                        }
                        if (response?.CustomData?.ANKETAREDIRECT == "1") {
                            window.location.href = '/MyCabinet/ClientFru';
                            return;
                        }
                        else if (response?.CustomData?.ANKETAREDIRECT == "2") {
                            window.location.href = '/MyCabinet/ClientUru';
                            return;
                        }
                        else {
                            this.redirectToReturnUrl();
                        }
                    }
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "TwoFactorAuthenticationRequired") {
                        var args = response.Error.Arguments.split('|');
                        this.handleTwoFactorAuthentication(request.Username, request.Password, args[1], args[0]);
                        return;
                    }

                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();
                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    public InstallPWAApp() {
        this.installButton = document.getElementById("install_button");

        var bResult = this.CheckDeviceIOS();
        $("#divInstallAppIos").hide();
        $("#install_buttonIos").hide();
        $("#rustore-link").hide();

        const mqStandAlone = '(display-mode: standalone)';

        if (bResult && !window.matchMedia(mqStandAlone).matches) {
            //IOS
            $("#divInstallAppIos").show();
            $("#install_buttonIos").show();

            $("#rustore-link").hide();

            $("#install_buttonIos").click(() => {
                window.open("/Content/site/PWAInstallation.pdf", '_blank').focus();
            });
        } else if (!window.matchMedia(mqStandAlone).matches) {
            //Другие
            window.addEventListener("beforeinstallprompt", e => {
                e.preventDefault();
                this.deferredPrompt = e;
                this.installButton.hidden = false;
                $("#divInstallApp").show();
                $("#rustore-link").show();
            });

            this.installButton.addEventListener("click", () => {
                this.deferredPrompt.prompt();
                this.installButton.disabled = true;
                $("#divInstallApp").hide();
                $("#rustore-link").hide();

                this.deferredPrompt.userChoice.then(choiceResult => {
                    if (choiceResult.outcome === "accepted") {
                        this.installButton.hidden = true;
                        $("#divInstallApp").hide();
                        $("#rustore-link").hide();
                    }
                    $("#divInstallApp").show();
                    $("#rustore-link").show();
                    this.installButton.disabled = false;
                });
            });
        }

        const isWideScreen = window.matchMedia('(min-width: 950px)').matches;
        if (isWideScreen) {
            $("#rustore-link").show();
        }
    }

    //protected redirectToReturnUrl() {
    //    var q = parseQueryString();
    //    var returnUrl = q['returnUrl'] || q['ReturnUrl'];
    //    if (returnUrl) {
    //        var hash = window.location.hash;
    //        if (hash != null && hash != '#')
    //            returnUrl += hash;
    //        window.location.href = returnUrl;
    //    }
    //    else {
    //        window.location.href = resolveUrl('~/');
    //    }
    //}

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];

        if (returnUrl && this.isLocalUrl(returnUrl)) {
            var hash = window.location.hash;
            if (hash && hash !== '#')
                returnUrl += hash;

            window.location.href = returnUrl;
        } else {
            // Если returnUrl не задан или внешний — редирект на главную
            window.location.href = resolveUrl('~/');
        }
    }

    private isLocalUrl(url: string): boolean {
        // Разрешаем только относительные URL внутри приложения
        return url.startsWith('/') &&
            !url.startsWith('//') &&
            !/^https?:/i.test(url);
    }

    protected handleTwoFactorAuthentication(user: string, pass: string, twoFactorGuid: string, info: string) {
        var tries = 0;
        var remaining = 120;

        var dialog = null;

        var showDialog = () => {
            dialog = new PromptDialog({
                title: "Two Factor Authentication",
                editorOptions: {
                    maxLength: 4,
                },
                editorType: "Integer",
                message: info,
                isHtml: true,
                required: true,
                validateValue: (x) => {
                    if (x >= 1000 && x <= 9999) {
                        tries++;

                        serviceCall({
                            url: resolveUrl('~/Account/Login'),
                            request: {
                                Username: user,
                                Password: pass,
                                TwoFactorGuid: twoFactorGuid,
                                TwoFactorCode: x
                            },
                            onSuccess: () => {
                                this.redirectToReturnUrl();
                                return;
                            },
                            onError: (z: ServiceResponse) => {
                                notifyError(z.Error.Message);

                                if (tries > 2) {
                                    notifyError("Code entered is invalid! You can't try more than 3 times!");
                                    dialog = null;
                                    return;
                                }

                                showDialog();
                            }
                        });

                        return true;
                    }

                    notifyError("Please enter a valid code!");
                    return false;
                }
            });

            dialog.dialogOpen();
            dialog.element.on("dialogclose.me", function (x) {
                if (dialog != null) {
                    dialog.element.off("dialogclose.me");
                    dialog = null;
                }
            });
        };

        function updateCounter() {
            remaining -= 1;
            if (dialog != null) {
                dialog.element.find("span.counter").text(remaining.toString());
            }

            if (remaining >= 0)
                setTimeout(updateCounter, 1000);
            else if (dialog != null)
                dialog.dialogClose();
        };

        showDialog();
        window.setTimeout(updateCounter, 1000);
    }

    protected getTemplate() {

        let sDABConfiguration = text("MyCabinet.LKDABConfiguration.DABConfiguration");
        let sSiteName = htmlEncode(text("Site.SiteName"));
        if (',gastransbank,caderus,metaxmarkets,'.indexOf(',' + sDABConfiguration + ',') > -1)
            sSiteName = '';

        var htmlForgotPassword = `
                <div style="padding-right: 0.75rem;padding-left: 0.75rem;text-align:end;">
                    <a href="/Account/ForgotPassword">${text("Forms.Membership.Login.ForgotPassword")}</a>
                </div>
            `;

        if (',caderus,absolut,metaxmarkets,specinvestment,noosfera,mospartners,solidbank,'.indexOf(',' + sDABConfiguration + ',') > -1) {
            return `
            <div class="s-Panel p-4">
                <h2 class="text-center p-4">
                    <img src="${resolveUrl("~/Content/site/images/companylogo.png")}"
                        style="width: 100%;" />
                </h2>
                ${(',metaxmarkets,'.indexOf(',' + sDABConfiguration + ',') > -1) ? `` : `<h5 class="text-center my-4">${htmlEncode(text("Forms.Membership.Login.LoginToYourAccount"))}</h5>`}
                <form id="~_Form" action="">
                    <div id="~_PropertyGrid"></div>
                    <div class="px-field">
                        <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                            ${htmlEncode(text("Forms.Membership.Login.SignInButton"))}
                        </button>
                    </div>
                </form>
                ${htmlForgotPassword}
                <div id="divInstallApp" style="padding-right: 0.75rem;padding-left: 0.75rem;margin-top:5px;text-align:end;">
                    <button style="background: none!important; border: none; padding: 0!important;font-family: arial, sans-serif;color: var(--bs-link-color);text-decoration: underline;cursor: pointer;" id="install_button" hidden>${text("Forms.Membership.Login.InstallApp")}</button>
                </div>
                <div id="divInstallAppIos" style="padding-right: 0.75rem;padding-left: 0.75rem;text-align:end;margin-top:5px;">
                    <button style="background: none!important; border: none; padding: 0!important;font-family: arial, sans-serif;color: var(--bs-link-color);text-decoration: underline;cursor: pointer;" id="install_buttonIos">${text("Forms.Membership.Login.InstallApp")}</button>
                </div>
            </div> 
            `;
        }
        else {
            return `
            <div class="s-Panel p-4">
                <h2 class="text-center p-4">
                    <img src="${resolveUrl("~/Content/site/images/companylogo.png")}"
                        ${(',zenit,'.indexOf(',' + sDABConfiguration + ',') > -1) ? `` : `style="background-color: var(--s-sidebar-band-bg)"`}/> ${sSiteName}
                </h2>
                ${(',metaxmarkets,'.indexOf(',' + sDABConfiguration + ',') > -1) ? `` : `<h5 class="text-center my-4">${htmlEncode(text("Forms.Membership.Login.LoginToYourAccount"))}</h5>`}
                <form id="~_Form" action="">
                    <div id="~_PropertyGrid"></div>
                    <div class="px-field">
                        <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                            ${htmlEncode(text("Forms.Membership.Login.SignInButton"))}
                        </button>
                    </div>
                </form>
                ${htmlForgotPassword}
                <div id="divInstallApp" style="padding-right: 0.75rem;padding-left: 0.75rem;text-align:end;margin-top:5px;">
                    <button style="background: none!important; border: none; padding: 0!important;font-family: arial, sans-serif;color: var(--bs-link-color);text-decoration: underline;cursor: pointer;" id="install_button" hidden>${text("Forms.Membership.Login.InstallApp")}</button>
                </div>
                <div id="divInstallAppIos" style="padding-right: 0.75rem;padding-left: 0.75rem;text-align:end;margin-top:5px;">
                    <button style="background: none!important; border: none; padding: 0!important;font-family: arial, sans-serif;color: var(--bs-link-color);text-decoration: underline;cursor: pointer;" id="install_buttonIos">${text("Forms.Membership.Login.InstallApp")}</button>
                </div>
            </div> 
            `;
        }
    }


    public CheckDeviceIOS(): boolean {
        const expression = /(Mac|iPhone|iPod|iPad)/i;
        var bResult = false;
        if (expression.test(navigator.platform)) {
            bResult = true;
        } else {
            bResult = false;
        }

        return bResult;
    }

    private addRuStoreButton(): void {

        // чтобы не добавить дважды
        if (document.getElementById("rustore-link"))
            return;

        const link = document.createElement("a");
        link.id = "rustore-link";
        link.href = "https://www.rustore.ru/catalog/app/com.dabsystems.dablk";
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.setAttribute("aria-label", "Скачать в RuStore");

        const img = document.createElement("img");
        img.src = resolveUrl("~/Content/site/images/RuStoreDownload.png");
        img.alt = "Скачать в RuStore";

        link.appendChild(img);
        document.body.appendChild(link);

        // стили
        const style = document.createElement("style");
        style.innerHTML = `
        #rustore-link {
            position: fixed;
            right: 24px;
            bottom: 20px;
            z-index: 9999;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
        }

        #rustore-link img {
            height: 44px;
            width: auto;
            display: block;
        }

        @media (max-width: 768px) {
            #rustore-link {
                right: 12px;
                bottom: 12px;
            }
            #rustore-link img {
                height: 44px;
            }
        }

        @media (max-width: 420px) {
            #rustore-link img {
                height: 38px;
            }
        }
    `;
        document.head.appendChild(style);
    }
}